import type { JSX } from 'react';

import { getConfig } from 'pkg/config/app';

type Props = {
	className?: string;
	src: string;
	alt?: string;
};

const AssetImage = ({ className, src, alt }: Props): JSX.Element => {
	let url = src;

	if (url.startsWith('/')) {
		url = url.substr(1, url.length);
	}

	if (!url.startsWith('http')) {
		url = getConfig().assetUrl.endsWith('/')
			? `${getConfig().assetUrl}${url}`
			: `${getConfig().assetUrl}/${url}`;
	}

	return <img src={url} className={className} alt={alt} />;
};

export default AssetImage;
